import React from "react";
import { motion } from "framer-motion";
import RevokeIcon from "../../../../assets/icons/revoke.svg";
import {
  Overlay,
  ModalHeader,
  PrimaryButton,
  SecondaryButton,
} from "../../../../components";

const DeleteUserInvitationConfirm = ({
  onClose,
  deleteUserInvitation,
  deleteInvitationFn,
}) => {
  const { userID } = deleteUserInvitation;
  const label = "Revoke";

  const handleInvitationDeleteClick = () => {
    deleteInvitationFn({ userID });
    onClose(false);
  };

  return (
    <React.Fragment>
      <Overlay />
      <div className="prompt">
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 0.3 }}
        >
          <ModalHeader
            title={label + " invitation?"}
            onClick={() => onClose(false)}
            img={RevokeIcon}
            alt={"revoke"}
          />
          <div className="modal_middle">
            <div className="deactivate-info">
              <p>What happens when an account is deleted?</p>
              <ul>
                <li>
                  The member will no longer be able to register in to workspace.
                </li>
              </ul>
            </div>
          </div>
          <div className="prompt-bottom" style={{ marginTop: 0 }}>
            <SecondaryButton label="Cancel" onClick={() => onClose(false)} />
            <PrimaryButton
              label={label}
              onClick={handleInvitationDeleteClick}
              extraClass="prompt-done"
            />
          </div>
        </motion.div>
      </div>
    </React.Fragment>
  );
};

export default DeleteUserInvitationConfirm;
